<template>
  <div class="p-3">
    <div class="bg-white border rounded p-4 mb-3">
      <div class="row">
        <div class="col-md-3 mb-3">
          <label for="personal-id" class="form-label">เลขบัตรประจำตัวประชาชน</label>
          <input
            name="personal_id"
            type="number"
            class="form-control valid"
            id="personal_id"
            aria-invalid="false"
            v-on:input="IDMaxLength"
            v-model="state.personal_id"
          />
          <span v-if="v$.personal_id.$error" class="require-txt">
            {{ v$.personal_id.$errors[0].$message }}
          </span>
        </div>
        <div class="col-md-2 mb-3">
          <label for="pre_name" class="form-label">คำนำหน้า</label>
          <input
            name="pre_name"
            type="text"
            class="form-control valid"
            id="pre_name"
            aria-invalid="false"
            v-model="state.pre_name"
          />
          <span v-if="v$.pre_name.$error" class="require-txt">
            {{ v$.pre_name.$errors[0].$message }}
          </span>
        </div>
        <div class="col-md-3 mb-3">
          <label for="name" class="form-label">ชื่อ</label>
          <input
            name="name"
            type="text"
            class="form-control valid"
            id="name"
            aria-invalid="false"
            v-model="state.name"
          />
          <span v-if="v$.name.$error" class="require-txt">
            {{ v$.name.$errors[0].$message }}
          </span>
        </div>
        <div class="col-md-3 mb-3">
          <label for="last_name" class="form-label">สกุล</label>
          <input
            name="last_name"
            type="text"
            class="form-control valid"
            id="last_name"
            aria-invalid="false"
            v-model="state.last_name"
          />
          <span v-if="v$.last_name.$error" class="require-txt">
            {{ v$.last_name.$errors[0].$message }}
          </span>
        </div>

        <div class="col-md-3 mb-3">
          <label for="mobile_number" class="form-label">หมายเลขโทรศัพท์มือถือ</label>
          <input
            name="mobile_number"
            type="text"
            class="form-control valid"
            id="mobile_number"
            aria-invalid="false"
            v-on:input="phoneLimitLength"
            v-model="state.mobile_number"
          />
          <span v-if="v$.mobile_number.$error" class="require-txt">
            {{ v$.mobile_number.$errors[0].$message }}
          </span>
        </div>
        <div class="col-md-3 mb-3">
          <label for="email" class="form-label">อีเมล</label>
          <input
            name="email"
            type="email"
            class="form-control valid"
            id="email"
            aria-invalid="false"
            v-model="state.email"
          />
          <span v-if="v$.email.$error" class="require-txt">
            {{ v$.email.$errors[0].$message }}
          </span>
        </div>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          value="true"
          id="flexCheckChecked"
          v-model="isRemembered"
        />
        <label class="form-check-label text-danger" for="flexCheckChecked">
          ต้องการบันทึกข้อมูลส่วนตัวนี้ไว้หรือไม่
          เพื่อในการบริจาคครั้งต่อไปท่านไม่จำเป็นต้องกรอกข้อมูลส่วนนี้อีก
        </label>
      </div>
    </div>
    <div class="bg-white border rounded p-4 mb-3">
      <span class="form-label">เลือกประเภทของผู้บริจาค</span>
      <div class="row">
        <div class="col-lg-4 col-sm-12">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="groupOfDonate"
              v-model="state.groupOfDonate"
              value="1"
              id="group1"
            />
            <label class="form-check-label" for="group1"> บุคคลทั่วไป/บริษัท </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="groupOfDonate"
              v-model="state.groupOfDonate"
              value="2"
              id="group2"
            />
            <label class="form-check-label" for="group2"> ศิษย์เก่ามหาวิทยาลัยทักษิณ </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="groupOfDonate"
              v-model="state.groupOfDonate"
              value="3"
              id="group3"
            />
            <label class="form-check-label" for="group3"> บุคลากรมหาวิทยาลัยทักษิณ </label>
          </div>
        </div>
        <div class="col-lg-8 col-sm-12 input-append">
          <div v-if="state.groupOfDonate == 1">
            <label for="organize_name" class="form-label">ชื่อบริษัท/ชื่อหน่วยงาน/ชื่อองค์กร</label>
            <input
              type="text"
              class="form-control"
              name="organize_name"
              id="organize_name"
              v-model="state.companyName"
              placeholder="บริษัท ABCD จำกัด"
            />
            <span class="text-danger">*เว้นว่างหากเป้นบุคคลทั่วไป</span>
          </div>
          <div v-if="state.groupOfDonate == 2">
            <label for="alumni_faculty" class="form-label">ศิษย์เก่าคณะ</label>
            <select v-model="state.selected" id="department" name="department" class="form-select">
              <option v-for="option in options" :value="option.NAME" :key="option.ID">
                {{ option.NAME }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white border rounded p-4 mb-3">
      <label for="inputAddress" class="form-label">ที่อยู่สำหรับออกใบเสร็จรับเงิน</label>
      <input
        type="text"
        name="address_receipt"
        class="address-receipt form-control valid"
        id="inputAddress"
        placeholder="140 หมู่4 ถ.กาญจนวณิชย์ อ.เมือง จ.สงขลา 90000"
        aria-invalid="false"
        v-model="state.receiptPrintAddress"
        v-on:keyup="isSameAddress"
      />
      <span v-if="v$.receiptPrintAddress.$error" class="require-txt">
        {{ v$.receiptPrintAddress.$errors[0].$message }}
      </span>
    </div>

    <div class="bg-white border rounded p-4 mb-3">
      <label for="inputAddress2" class="form-label">ที่อยู่สำหรับจัดส่งใบเสร็จ</label>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="receipt"
          v-on:change="isSameAddress"
          v-model="isReceiptyMyself"
          :value="false"
          id="sameaddrs"
        />
        <label class="form-check-label" for="sameaddrs">
          ใช้ที่อยู่เดียวกันกับที่อยู่สำหรับออกใบเสร็จ
        </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="receipt"
          v-on:change="isSameAddress"
          :value="true"
          v-model="isReceiptyMyself"
          id="myself"
        />
        <label class="form-check-label" for="myself"> มารับด้วยตนเองที่มหาวิทยาลัยทักษิณ </label>
      </div>
      <div class="ps-4">
        <span class="text-danger" style="font-size: 14px"
          >วิทยาเขตสงขลารับ ณ ฝ่ายการคลังและทรัพย์สิน อาคาร 50 ปี (ตึก 18) ชั้น 2</span
        >
        <br />
        <span class="text-danger" style="font-size: 14px"
          >วิทยาเขตพัทลุงรับ ณ ฝ่ายการคลังและทรัพย์สิน อาคารบริหารและสำนักงานกลาง (ตึกโดม) ชั้น
          2</span
        >
      </div>
      <input
        type="text"
        name="address_send_receipt"
        class="address-send-receipt form-control valid"
        id="inputAddress2"
        placeholder="140 หมู่4 ถ.กาญจนวณิชย์ อ.เมือง จ.สงขลา 90000"
        aria-invalid="false"
        v-model="state.receiptPostAddress"
      />
      <span v-if="v$.receiptPostAddress.$error" class="require-txt">
        {{ v$.receiptPostAddress.$errors[0].$message }}
      </span>
    </div>
    <div class="col-12 d-flex justify-content-end">
      <button
        type="submit"
        class="btn btn-next-step btn-lg btn-warning"
        @click.prevent="submitForm"
      >
        <i class="bi bi-2-circle-fill fs-3"></i> ขั้นตอนถัดไป
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required, email, numeric, minLength, maxLength, helpers } from '@vuelidate/validators';
import { isValidThaiId } from './scripts/thaiId';
import { useDepartments } from './scripts/useDepartments';
import { useRememberUser } from './scripts/useRememberUser';
import { useDonateInfoCookie } from './scripts/useDonateInfoCookie';

const props = defineProps({
  campaignID: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['gotoStep']);

const { options } = useDepartments();
const { saveRememberUser, getRememberUser } = useRememberUser();
const { setDonateInfoCookie, getDonateInfoCookie } = useDonateInfoCookie();

const isReceiptyMyself = ref(false);
const isRemembered = ref(false);

const state = reactive({
  pre_name: '',
  name: '',
  last_name: '',
  personal_id: '',
  mobile_number: '',
  email: '',
  receiptPrintAddress: '',
  receiptPostAddress: '',
  groupOfDonate: '',
  groupName: '',
  companyName: '',
  selected: '',
});

const rules = {
  pre_name: { required },
  name: { required },
  last_name: { required },
  // checksum กันเลขพิมพ์ผิด — 13 หลักครบแต่ผิด checksum ทำให้ callback ธนาคาร
  // จับคู่ Donation ไม่ได้ตลอดกาล ดู frontend/src/components/scripts/thaiId.js
  personal_id: {
    required,
    numeric,
    minLength: minLength(13),
    maxLength: maxLength(13),
    // helpers.req กันไม่ให้ช่องว่างเด้งสองข้อความพร้อมกัน ปล่อยให้ required จัดการเอง
    thaiId: helpers.withMessage('เลขบัตรประจำตัวประชาชนไม่ถูกต้อง', (v) => !helpers.req(v) || isValidThaiId(v)),
  },
  mobile_number: { required, numeric, minLength: minLength(10), maxLength: maxLength(10) },
  email: { required, email },
  receiptPrintAddress: { required },
  receiptPostAddress: { required },
};

const v$ = useVuelidate(rules, state);

const gotoStep = (step) => {
  emit('gotoStep', step);
};

const isSameAddress = () => {
  if (isReceiptyMyself.value === false) {
    state.receiptPostAddress = state.receiptPrintAddress;
  } else if (isReceiptyMyself.value) {
    state.receiptPostAddress = 'รับด้วยตัวเอง';
  }
};

const submitForm = async () => {
  const result = await v$.value.$validate();
  if (result) {
    if (state.groupOfDonate == 1) {
      state.groupName = state.companyName;
    } else if (state.groupOfDonate == 2) {
      state.groupName = state.selected;
    } else {
      state.groupName = '';
    }

    const stepOne = {
      step1: { ...state, campaignID: props.campaignID },
    };
    setDonateInfoCookie(stepOne);

    if (isRemembered.value) {
      const remember_user = {
        prefix: state.pre_name,
        name: state.name,
        surname: state.last_name,
        mobile_number: state.mobile_number,
        identification_number: state.personal_id,
        email: state.email,
      };
      await saveRememberUser(remember_user);
    }

    gotoStep(2);
  }
};

const IDMaxLength = (event) => {
  const maxLength = 13;
  state.personal_id = event.target.value.slice(0, maxLength);
};

const phoneLimitLength = (event) => {
  const maxLength = 10;
  state.mobile_number = event.target.value.slice(0, maxLength);
};

watch(() => state.personal_id, async (newValue) => {
  if (newValue.length === 13) {
    const response = await getRememberUser(newValue);
    if (response) {
      state.pre_name = response.PREFIX;
      state.name = response.NAME;
      state.last_name = response.SURNAME;
      state.mobile_number = response.PHONE_NUMBER;
      state.email = response.EMAIL;
    }
  }
});

onMounted(() => {
  const cookieData = getDonateInfoCookie();
  // เดิมเช็กแค่ว่ามีคุกกี้ คุกกี้ที่มี step2 แต่ไม่มี step1 จึงทำให้หน้านี้ TypeError หน้าขาว
  // ซึ่งเป็นหน้าเดียวที่ผู้บริจาคใช้กู้คืนข้อมูลตัวเองได้ ปิดทางกู้คืนไปอีกชั้น
  if (cookieData?.step1) {
    const _data = cookieData.step1;
    state.pre_name = _data.pre_name;
    state.name = _data.name;
    state.last_name = _data.last_name;
    state.email = _data.email;
    state.mobile_number = _data.mobile_number;
    state.personal_id = _data.personal_id;
    state.receiptPrintAddress = _data.receiptPrintAddress;
    state.receiptPostAddress = _data.receiptPostAddress;
    state.groupOfDonate = _data.groupOfDonate;
    state.companyName = _data.companyName;
    state.selected = _data.selected;
  }
});

</script>

<style>
.require-txt {
  color: #f30808;
}
</style>